// ?bench=1: a fixed, repeatable benchmark. It plays the bundled recording from a busy stretch
// (the pack mid-race running into the first catnip trip) with the director cutting as usual,
// and reports frame-time percentiles and scene cost on window.__catDerby.bench.
// Run it once per tier: ?bench=1&quality=low|medium|high.
import { percentile } from '../world/quality';

/** Where in the recording the benchmark starts (s), how long it warms up and measures (ms). */
export const BENCH_SEEK_S = 120;
export const BENCH_WARMUP_MS = 3000;
export const BENCH_MEASURE_MS = 30000;

export interface BenchSummary {
  p50: number; p95: number; p99: number; frames: number;
  tier?: string; meanFps?: number; drawCalls?: number; triangles?: number; renderScale?: number;
}

/** Summarises measured frame times (ms). Pure. */
export function summariseBench(times: number[], extra: Omit<BenchSummary, 'p50' | 'p95' | 'p99' | 'frames' | 'meanFps'> = {}): BenchSummary {
  const total = times.reduce((a, b) => a + b, 0);
  return {
    p50: percentile(times, 0.5), p95: percentile(times, 0.95), p99: percentile(times, 0.99),
    frames: times.length, meanFps: times.length && total > 0 ? (times.length * 1000) / total : 0,
    ...extra,
  };
}

/** Collects frame times after a warm-up and calls `done` once the measuring span is over. */
export class BenchRun {
  private elapsed = 0;
  private times: number[] = [];
  private draws: number[] = [];
  private tris: number[] = [];
  finished = false;

  constructor(private done: (s: BenchSummary) => void, private warmupMs = BENCH_WARMUP_MS, private measureMs = BENCH_MEASURE_MS) {}

  frame(dtMs: number, drawCalls: number, triangles: number, info: { tier: string; renderScale: number }): void {
    if (this.finished) return;
    this.elapsed += dtMs;
    if (this.elapsed <= this.warmupMs) return;
    this.times.push(dtMs); this.draws.push(drawCalls); this.tris.push(triangles);
    if (this.elapsed >= this.warmupMs + this.measureMs) {
      this.finished = true;
      this.done(summariseBench(this.times, {
        tier: info.tier, renderScale: info.renderScale,
        drawCalls: Math.round(percentile(this.draws, 0.5)), triangles: Math.round(percentile(this.tris, 0.5)),
      }));
    }
  }
}
